import { gql } from '@/__generated__';

export const GET_VISIBLE_UNITS = gql(`#graphql
  query GetVisibleUnits($id: Int) {
    user(id: $id) {
      id
      preferences {
        id
        visibleUnits
      }
    }
  }
`);
